import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56777214"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "remove-patient" }

import { PropType } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { usePatientListing } from '@/shared/composables'
import { patientApi } from '@/shared/api/'
import { showErrorMessage } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  patientId: String as PropType<string | string[]>,
},
  setup(__props) {

const props = __props



const router = useRouter()
const { updatePatientListing } = usePatientListing()

const removePatient = async (): Promise<void> => {
  const [error] = await patientApi.removePatient(Number(props.patientId))

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Пациент удален',
      type: 'success',
    })

    updatePatientListing(true)
    router.push({ name: 'PatientListingPage' })
  }
}

const handleRemovePatient = (): void => {
  ElMessageBox.confirm('Подтвердите удаление пациента', 'Удаление', {
    confirmButtonText: 'Подтвердить',
    cancelButtonText: 'Отмена',
    type: 'warning',
  }).then(() => {
    removePatient()
  })
}

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!

  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createVNode(_component_icon_template, {
      name: "remove",
      width: "12",
      height: "12",
      onClick: handleRemovePatient
    })
  ]))
}
}

})